module.exports = __webpack_public_path__ + "images/file_icons_v2/iso-1e9b5e18adadcec1d8522d2623b049a3.svg";